"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSystem = exports.fetchExcelInfoFailed = exports.fetchExcelInfoSuccess = exports.fetchExcelInfoRequest = exports.uploadTranslationsFileSuccess = exports.uploadTranslationsFileFailed = exports.setTranslationsFile = exports.uploadTranslationsFile = exports.setStandby = exports.fetchLanguageFailed = exports.fetchLanguageSuccess = exports.fetchLanguageRequest = void 0;
const ActionTypes = require("../actionTypes/translations");
function fetchLanguageRequest(language, isProduction) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        payload: {
            language,
            isProduction
        }
    };
}
exports.fetchLanguageRequest = fetchLanguageRequest;
function fetchLanguageSuccess(language) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload: {
            language
        }
    };
}
exports.fetchLanguageSuccess = fetchLanguageSuccess;
function fetchLanguageFailed(error) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload: {
            error
        }
    };
}
exports.fetchLanguageFailed = fetchLanguageFailed;
function setStandby() {
    return {
        type: ActionTypes.SET_STANDBY
    };
}
exports.setStandby = setStandby;
function uploadTranslationsFile(file) {
    return {
        type: ActionTypes.UPLOAD_TRANSLATIONS_FILE,
        payload: {
            file
        }
    };
}
exports.uploadTranslationsFile = uploadTranslationsFile;
function setTranslationsFile(file) {
    return {
        type: ActionTypes.SET_TRANSLATIONS_FILE,
        payload: {
            file
        }
    };
}
exports.setTranslationsFile = setTranslationsFile;
function uploadTranslationsFileFailed(error) {
    return {
        type: ActionTypes.UPLOAD_TRANSLATIONS_FILE_FAILED,
        payload: {
            error
        }
    };
}
exports.uploadTranslationsFileFailed = uploadTranslationsFileFailed;
function uploadTranslationsFileSuccess(status) {
    return {
        type: ActionTypes.UPLOAD_TRANSLATIONS_FILE_SUCCESS,
        payload: {
            status
        }
    };
}
exports.uploadTranslationsFileSuccess = uploadTranslationsFileSuccess;
function fetchExcelInfoRequest() {
    return {
        type: ActionTypes.FETCH_EXCEL_INFO_REQUEST
    };
}
exports.fetchExcelInfoRequest = fetchExcelInfoRequest;
function fetchExcelInfoSuccess(info) {
    return {
        type: ActionTypes.FETCH_EXCEL_INFO_SUCCESS,
        payload: {
            info
        }
    };
}
exports.fetchExcelInfoSuccess = fetchExcelInfoSuccess;
function fetchExcelInfoFailed(error) {
    return {
        type: ActionTypes.FETCH_EXCEL_INFO_FAILED,
        payload: {
            error
        }
    };
}
exports.fetchExcelInfoFailed = fetchExcelInfoFailed;
function clearSystem() {
    return {
        type: ActionTypes.CLEAR_SYSTEM
    };
}
exports.clearSystem = clearSystem;
//# sourceMappingURL=translations.js.map